import { RootState } from 'App';
import deepEqualsCreateSelector from 'utils/deepEqualsCreateSelector';
import { EListsTypes } from 'types/listsTypes';
import { ERoutePaths } from 'types/routes/enums';

type TListType = { listType: EListsTypes }

export const selectIsBulkActivating = ({ lists }: RootState) => lists.products.isBulkActivating;

export const productTagsSelector = deepEqualsCreateSelector(
  ({ lists }: RootState) => lists.products,
  ({ tags }) => tags,
);

export const productShopifyCollectionSelector = deepEqualsCreateSelector(
  ({ lists }: RootState) => lists.products,
  ({ shopifyCollections }) => shopifyCollections,
);

export const resultsByTypeSelector = deepEqualsCreateSelector(
  ({ lists }: RootState, { listType }: TListType) => ({ list: lists[listType] }),
  ({ list }) => list.results,
);

export const activeFiltersByTypeSelector = deepEqualsCreateSelector(
  ({ lists }: RootState, { listType }: TListType) => ({ list: lists[listType] }),
  ({ list }) => list.activeFilters,
);

export const paginationByTypeSelector = deepEqualsCreateSelector(
  ({ lists }: RootState, { listType }: TListType) => ({ list: lists[listType] }),
  ({ list }) => list.pagination,
);

export const tableSettingsByTypeSelector = deepEqualsCreateSelector(
  ({ lists }: RootState, { listType }: TListType) => ({ list: lists[listType] }),
  ({ list }) => list.tableSettings,
);

// export const savedFiltersByTypeSelector = deepEqualsCreateSelector(
//   [(state, { listType }: ISelectorByTypeProps) => ({ lists: listsSelector(state), listType })],
//   ({ lists, listType }) => lists[listType].savedFilters,

export const headerCountByPathnameSelector = deepEqualsCreateSelector(
  [({ lists }: RootState, { pathname }: { pathname: ERoutePaths }) => ({ lists, pathname })],
  ({ lists, pathname }) => {
    const countByType = {
      [ERoutePaths.Products]: lists.products.pagination.totalResults,
      [ERoutePaths.Orders]: lists.orders.pagination.totalResults,
    };

    // @ts-ignore
    return countByType[pathname];
  },
);
